import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BookOpenIcon, ChevronDownIcon, Clock3Icon, ListChecksIcon } from 'lucide-react';
import { IMAGES, TOMOS } from '../data/landing';
export function SolutionSection() {
  const [openTomo, setOpenTomo] = useState<number | null>(0);
  return <section className="w-full bg-neutral-950 py-10 text-white sm:py-16" data-id="element-223" data-mp="3j95zd92qpt3n">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-224" data-mp="142r5fhh90z0">
        <div className="mx-auto max-w-2xl text-center" data-id="element-225" data-mp="12hxds2zlm27">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-yellow-400 px-3 py-1 text-xs font-black uppercase text-neutral-900" data-id="element-226" data-mp="3t96lf2rzunbj">
            <BookOpenIcon className="h-3.5 w-3.5" data-id="element-227" data-mp="awi8caky9liu" /> La solución
          </span>
          <h2 className="mt-4 text-2xl font-black leading-tight sm:text-3xl lg:text-4xl" data-id="element-228" data-mp="5vukfxs0pksu">
            Este no es otro PDF de recetas.
          </h2>
          <p className="mt-3 text-base leading-relaxed text-neutral-300 sm:text-lg" data-id="element-229" data-mp="ftqv6oh1mdqf">
            Es la <span className="font-bold text-yellow-400" data-id="element-230" data-mp="36am3plcfuw3f">biblioteca de cocina moderna</span> que hará que tu máquina se pague sola la primera semana.
          </p>
        </div>

        <img src={IMAGES.mockupPrincipal} alt="Los 4 tomos del MegaPack Air Fryer Argentina" className="mx-auto mt-8 w-full max-w-2xl rounded-2xl drop-shadow-[0_24px_32px_rgba(0,0,0,0.5)]" data-id="element-231" data-mp="3bbt9jev0tl7g" />

        <div className="mt-10" data-id="element-232" data-mp="3p9q4y7xqnlkj">
          <div className="mb-5 text-center" data-id="element-233" data-mp="3p8ovg7wdf74x">
            <p className="text-lg font-black text-white sm:text-xl" data-id="element-234" data-mp="3p7ngvtg5c2ig">
              Espiá el índice de cada tomo
            </p>
            <p className="mt-1 text-sm text-neutral-400" data-id="element-235" data-mp="2tdn14tg62aa">
              Una muestra de los clásicos argentinos que vas a poder hacer desde el primer día.
            </p>
          </div>

          <div className="grid gap-4 sm:grid-cols-2" data-id="element-236" data-mp="butv35wshsbc">
            {TOMOS.map((tomo, index) => {
            const isOpen = openTomo === index;
            return <motion.article key={tomo.numero} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.08
            }} className="overflow-hidden rounded-2xl border border-neutral-800 bg-neutral-900" data-id="element-237" data-mp="grkd3ys5mxze" data-mpi={index}>
                  <button type="button" onClick={() => setOpenTomo(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`indice-${index}`} className="flex w-full items-start justify-between gap-4 p-5 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-4px] focus-visible:outline-yellow-400" data-id="element-238" data-mp="2hu30ljrxt318">
                    <span data-id="element-239" data-mp="1b8iovnuzey7b">
                      <span className="inline-block rounded-md px-2.5 py-1 text-xs font-black uppercase text-neutral-900" style={{
                    backgroundColor: tomo.color
                  }} data-id="element-240" data-mp="1b7pn71avqyw1">
                        {tomo.numero}
                      </span>
                      <span className="mt-3 block text-xl font-bold text-white" data-id="element-241" data-mp="3mu1cza14qa19">{tomo.titulo}</span>
                      <span className="mt-1.5 block text-sm text-neutral-400" data-id="element-242" data-mp="383u0rc1ptn90">{tomo.descripcion}</span>
                      <span className="mt-3 flex items-center gap-1.5 text-xs font-bold uppercase tracking-wide text-neutral-300" data-id="element-243" data-mp="3d2wtbx0ie103">
                        <Clock3Icon className="h-3.5 w-3.5" style={{
                      color: tomo.color
                    }} data-id="element-244" data-mp="3441rex4hzd2l" />
                        {tomo.rango}
                      </span>
                    </span>
                    <ChevronDownIcon className={`mt-1 h-6 w-6 shrink-0 text-neutral-400 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-245" data-mp="2u65f41ztqc2w" />
                  </button>

                  <AnimatePresence initial={false} data-id="element-246" data-mp="se8tu0nutnux">
                    {isOpen && <motion.div id={`indice-${index}`} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.25
                }} className="overflow-hidden" data-id="element-247" data-mp="2oglzex765krv">
                        <div className="border-t border-neutral-800 px-5 pb-5 pt-4" data-id="element-248" data-mp="25k2u6izhkh0l">
                          <p className="text-sm leading-relaxed text-neutral-300" data-id="element-249" data-mp="20s2osb0ncvwm">{tomo.enfoque}</p>
                          <div className="mt-4 rounded-xl bg-neutral-950 p-4" data-id="element-250" data-mp="1wpy1rv4pexiy">
                            <p className="flex items-center gap-2 text-xs font-black uppercase tracking-wider text-yellow-400" data-id="element-251" data-mp="1rrwhj6vjks5w">
                              <ListChecksIcon className="h-4 w-4" data-id="element-252" data-mp="1mri7jjadr858" /> Índice destacado
                            </p>
                            <ol className="mt-3 space-y-2" data-id="element-253" data-mp="1hu06ef2ltx7s">
                              {tomo.destacados.map((receta, recipeIndex) => <li key={receta} className="flex items-start gap-2 text-sm text-neutral-200" data-id="element-254" data-mp="1commmgn4nbzt" data-mpi={recipeIndex}>
                                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-[10px] font-black text-neutral-950" style={{
                            backgroundColor: tomo.color
                          }} data-id="element-255" data-mp="1hnzc795dux63">
                                    {recipeIndex + 1}
                                  </span>
                                  {receta}
                                </li>)}
                            </ol>
                          </div>
                          <p className="mt-4 border-l-2 pl-3 text-xs font-semibold leading-relaxed text-neutral-400" style={{
                      borderColor: tomo.color
                    }} data-id="element-256" data-mp="13pre2xwm1ptc">
                            {tomo.masRecetas}
                          </p>
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </motion.article>;
          })}
          </div>
        </div>
      </div>
    </section>;
}